import {inject} from '@angular/core';
import {CanActivateChildFn} from '@angular/router';
import {ApiTokenService} from '../services/ApiTokenService';

export const apiTokenChildGuard: CanActivateChildFn = () => inject(ApiTokenService).ensureTokenForNavigation();
